import React, { useState } from 'react';
import TimeEventJsonViewer from './TimeEventJsonViewer';

const TimeEventTableViewer = ({ 
  title, 
  data, 
  fieldId, 
  onSave, 
  caseid,
  tag = null, // Add tag prop to pass to TimeEventJsonViewer
  children 
}) => {
  const [jsonViewDialog, setJsonViewDialog] = useState(false);

  const openJsonViewer = (e) => {
    if (e) {
      e.stopPropagation();
    }
    setJsonViewDialog(true);
  };

  const closeJsonViewer = () => {
    setJsonViewDialog(false);
  };

  const handleSaveJson = (editedJsonData) => {
    if (onSave) {
      onSave(editedJsonData);
    }
    closeJsonViewer();
  };

  return (
    <>
      {/* Render children as function with openJsonViewer passed */}
      {typeof children === 'function' ? children(openJsonViewer) : children}
      
      {/* JSON Viewer Dialog */}
      <TimeEventJsonViewer
        open={jsonViewDialog}
        onClose={closeJsonViewer}
        title={title}
        data={data}
        fieldId={fieldId}
        onSave={handleSaveJson}
        caseid={caseid}
        tag={tag}
      />
    </>
  );
};

export default TimeEventTableViewer;
